export const listItems = [
  `1993г. Ю. Зюдхаймером образована компания Sudheimer Car Technik Vertriebs GmbH, которая специализируется на продаже смазочных материалов и запасных частей`,
  `1999г. Регистрация торговых марок SCT-GERMANY и MANNOL. Вывод первых 58 артикулов масляных, воздушных и топливных фильтров на рынок`,
  `2003г. Расширение ассортимента, тормозные колодки и лампы`,
  `2004г. Интеграция компании OR-TURBO FİLTRE San. Tic (Турция)`,
  `2008г. Расширение ассортимента (амортизаторы, ремни, подшипники, лампы и др.)`,
  `2009г. Открытие представительства в Южной Америке`,
  `2019г. Открытие официального представительства в России ООО «ЛЕГЕНД ГРУПП»`,
  `2020г. Открытие представительства в Северной Америке`,
  `2023г. Компании 30 лет (присутствие на 5-ти континентах более чем в 120 странах мира)`,
];
